module.exports = __webpack_public_path__ + "img/139.3.74e6899a.png";